<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('staminaLevel.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 0}" @click="changeTimeType(0, $t('dailyActive.time0'))">{{ $t('dailyActive.time0') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 1}" @click="changeTimeType(1, $t('dailyActive.time1'))">{{ $t('dailyActive.time1') }}</div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{time}}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
            </div>
            <div id="chart-box"></div>
            <div class="legend-box" v-if="$i18n.locale == 'zh'">
                <div class="legend-bar1 legend-bar"></div>
                <div class="legend-bar2 legend-bar"></div>
                <div class="legend-bar3 legend-bar"></div>
                <div class="legend-bar4 legend-bar"></div>
                <div class="legend-bar5 legend-bar"></div>
                <div class="legend-bar6 legend-bar"></div>
                <div class="legend-bar7 legend-bar"></div>
                <div class="legend-text1 legend-text"> {{$t('staminaLevel.level0')}}</div>
                <div class="legend-text2 legend-text"> {{$t('staminaLevel.level1')}}</div>
                <div class="legend-text3 legend-text"> {{$t('staminaLevel.level2')}}</div>
                <div class="legend-text4 legend-text"> {{$t('staminaLevel.level3')}}</div>
                <div class="legend-text5 legend-text"> {{$t('staminaLevel.level4')}}</div>
                <div class="legend-text6 legend-text"> {{$t('staminaLevel.level5')}}</div>
                <div class="legend-text7 legend-text"> {{$t('staminaLevel.level6')}}</div>
            </div>
            <div class="legend-box" v-if="$i18n.locale == 'en'">
                <div class="legend-bar11 legend-bar"></div>
                <div class="legend-bar22 legend-bar"></div>
                <div class="legend-bar33 legend-bar"></div>
                <div class="legend-bar44 legend-bar"></div>
                <div class="legend-bar55 legend-bar"></div>
                <div class="legend-bar66 legend-bar"></div>
                <div class="legend-bar77 legend-bar"></div>
                <div class="legend-text11 legend-text"> {{$t('staminaLevel.level0')}}</div>
                <div class="legend-text22 legend-text"> {{$t('staminaLevel.level1')}}</div>
                <div class="legend-text33 legend-text"> {{$t('staminaLevel.level2')}}</div>
                <div class="legend-text44 legend-text"> {{$t('staminaLevel.level3')}}</div>
                <div class="legend-text55 legend-text"> {{$t('staminaLevel.level4')}}</div>
                <div class="legend-text66 legend-text"> {{$t('staminaLevel.level5')}}</div>
                <div class="legend-text77 legend-text"> {{$t('staminaLevel.level6')}}</div>
            </div>
        </div>
        <div class="math-box">
            <van-row>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.maxData ? mathData.maxData : '--'}}</div>
                        <div class="math-text">{{$t('staminaLevel.math0')}}</div>
                    </div>
                </van-col>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.minData ? mathData.minData : '--'}}</div>
                        <div class="math-text">{{$t('staminaLevel.math1')}}</div>
                    </div>
                </van-col>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.avgData ? mathData.avgData : '--'}}</div>
                        <div class="math-text">{{$t('staminaLevel.math2')}}</div>
                    </div>
                </van-col>
            </van-row>
        </div>
        <div class="desc-box">
            <div class="desc-title">{{$t('staminaLevel.descTitle')}}</div>
            <div class="desc-info desc-last">
                {{$t('staminaLevel.desc0')}}
                <br>
                {{$t('staminaLevel.desc1')}}
                <br>
                {{$t('staminaLevel.desc2')}}
                <br>
                {{$t('staminaLevel.desc3')}}
                <br>
                {{$t('staminaLevel.desc4')}}
                <br>
                {{$t('staminaLevel.desc5')}}
                <br>
                {{$t('staminaLevel.desc6')}}
                <br>
                {{$t('staminaLevel.desc7')}}
                <br>
                {{$t('staminaLevel.desc8')}}

            </div>
        </div>
    </div>
</template>

<script>
    import {getQueryVariable, getSkin} from '@/utils/comment'
    import {
        getToday,
        getNWeekFirstDay,
        getNWeekLastDay,
        getMonthStartDay,
        getMonthEndDay,
        GetDateStr, SwitchTime24,
        changeDate,
        changeMonthDate,
        GetYear
    } from "../../utils/dateUtils";
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'staminaLevel',
        data() {
            return {
                ratio: 1,
                theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
                activeTime: 0,
                timeUnit: '',
                time: '',
                startDate: '',
                endDate: '',
                wNum: 0,
                mNum: 0,
                showTimeBox: false,
                info: {},
                mathData: {},
                myChart: null,
                showLeftOpacity: 0,
                showRightOpacity: 1
            }
        },
        watch: {
            showTimeBox: {
                handler(newVal, olVal) {
                    if (newVal) {
                        setTimeout(() => {
                            document.addEventListener('click', this.checkClick);
                        }, 0);
                    } else {
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            }
        },
        mounted() {
            this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
            this.timeUnit = this.$t('staminaLevel.time0');
            this.startDate = getNWeekFirstDay(this.wNum);
            this.endDate = getNWeekLastDay(this.wNum);
            this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            this.getData();
        },
        methods: {
            back() {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            },
            checkClick(event) {
                let dom = this.$refs.showContent; // 这里是你的下拉菜单元素
                if (!dom.contains(event.target)) {
                    // 不在菜单范围，隐藏即可
                    if (this.showTimeBox) {
                        this.showTimeBox = false;
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            },
            checkOpacity() {
                if (this.activeTime == 0 && this.wNum >= 0) {
                    this.showRightOpacity = 1
                } else if (this.activeTime == 1 && this.mNum >= 0) {
                    this.showRightOpacity = 1
                } else {
                    this.showRightOpacity = 0
                }
                if (this.activeTime == 0 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else {
                    this.showLeftOpacity = 0
                }
            },
            timeLeft() {
                if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                    this.wNum--;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                    this.mNum--;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            timeRight() {
                if (this.activeTime == 0 && this.wNum < 0) {
                    this.wNum++;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1 && this.mNum < 0) {
                    this.mNum++;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            changeTimeType(num, unit) {
                this.activeTime = num;
                this.timeUnit = unit;
                this.showTimeBox = false;
                if (this.activeTime == 0) {
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                }
                if (this.activeTime == 1) {
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            getData() {
                this.checkOpacity();
                this.$api.status.queryStaminaLevel({
                    startDate: this.startDate,
                    endDate: this.endDate
                }).then(res => {
                    if (res.result == 1) {
                        this.info = res.info;
                        this.mathData.maxData = res.info.staminaLevelMath.max;
                        this.mathData.avgData = res.info.staminaLevelMath.avg;
                        this.mathData.minData = res.info.staminaLevelMath.min;
                        this.info.dateArr = [];
                        this.info.dataArr = [];
                        this.info.dataAerArr = [];
                        this.info.dataAnaerArr = [];
                        for (let i = 0; i < this.info.data.length; i++) {
                            this.info.dateArr.push(this.info.data[i].date);
                            let color;
                            let data = this.info.data[i].staminaLevel;
                            if (data >= 10 && data < 80) {
                                color = this.getLevelColor(data)
                            } else {
                                data = null
                            }
                            let style = {
                                value: data,
                                itemStyle: {
                                    color: color
                                },
                                emphasis: {
                                    itemStyle: {
                                        borderColor: color,
                                        borderWidth: 1.5 * this.ratio,
                                        color: 'transparent'
                                    }
                                }
                            }
                            this.info.dataArr.push(style);
                            this.info.dataAerArr.push(this.info.data[i].staminaLevelAerobic);
                            this.info.dataAnaerArr.push(this.info.data[i].staminaLevelAnaerobic);
                        }
                        this.$nextTick(function () {
                            this.drawChart()
                            this.$forceUpdate()
                        })
                    }
                })
            },
            getLevelColor(level) {
                let color;
                if (level >= 10 && level < 20) {
                    color = getSkin('--chart-color-10');
                } else if (level < 30) {
                    color = getSkin('--chart-color-8');
                } else if (level < 40) {
                    color = getSkin('--chart-color-14');
                } else if (level < 50) {
                    color = getSkin('--chart-color-1');
                } else if (level < 60) {
                    color = getSkin('--chart-color-15');
                } else if (level < 70) {
                    color = getSkin('--chart-color-5');
                } else if (level <= 80) {
                    color = getSkin('--chart-color-3');
                }
                return color;
            },
            drawChart() {
                if (!this.myChart) {
                    this.myChart = this.$echarts.init(document.getElementById("chart-box"));
                }
                let _this = this;
                if (!this.mathData.avgData) {
                    this.myChart.setOption({
                        title: {
                            text: this.$t('noData'),
                            x: 'center',
                            y: 76 * this.ratio,
                            textStyle: {
                                fontFamily: 'SF',
                                fontSize: 12 * this.ratio,
                                fontWeight: 'normal',
                                color: getSkin('--text-color-2')
                            }
                        },
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                formatter: function (value) {
                                    return changeDate(value)
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            data: this.info.dateArr
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            min: 0,
                            max: 80,
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            }
                        },
                        series: [
                            {
                                data: [0, 0, 0],
                                type: 'bar',
                                symbol: 'none',
                                smooth: false,
                                barWidth: 10,
                                lineStyle: {
                                    width: 3
                                }
                            }
                        ]
                    }, true);
                } else {
                    this.myChart.setOption({
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        dataZoom: { // 放大和缩放
                            type: 'inside'
                        },
                        tooltip: {
                            backgroundColor: getSkin('--bg-color-2'),
                            trigger: 'axis',
                            position: (point, params, dom, rect, size) => {
                                let x = point[0]-size.contentSize[0]/2;
                                let cWidth = 375 * _this.ratio;
                                if (x < 0) {
                                    x = 0;
                                } else if ((x + size.contentSize[0]) > cWidth ) {
                                    x =  cWidth - size.contentSize[0];
                                }
                                return [x, '0%'];
                            },
                            formatter: function (params, ticket, callback) {
                                let item = params[0];
                                let value = item.value ? item.value : 0;
                                if (value == 0) {
                                    return
                                }
                                let index = item.dataIndex
                                let aerData = _this.info.dataAerArr[index];
                                let anaerData = _this.info.dataAnaerArr[index];
                                let html = '';
                                html += '<div style="font-family:SF;font-size:13px;color: ' + getSkin('--text-color-3') + '">' + changeDate(item.axisValue) + '</div>'
                                html += '<div style="font-family:SF;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> ' + _this.$t('staminaLevel.unit0') + '</div>'
                                html += '<div style="font-family:SF;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + aerData + '</span> ' + _this.$t('staminaLevel.unit1') + '</div>'
                                html += '<div style="font-family:SF;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + anaerData + '</span> ' + _this.$t('staminaLevel.unit2') + '</div>'
                                return html
                            }
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                formatter: function (value) {
                                    return changeDate(value)
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            data: this.info.dateArr
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            min: 0,
                            max: 80,
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            }
                        },
                        series: [
                            {
                                data: this.info.dataArr,
                                type: 'scatter',
                                symbolSize: 6 * this.ratio,
                            }
                        ]
                    }, true);
                }
            }
        }
    }
</script>

<style scoped>

    #chart-box {
        height: 198px;
        width: 100%;
    }

    .legend-box {
        width: 100%;
        height: 56px;
        /*background-color: #20D38F;*/
        position: relative;
    }

    .legend-bar {
        position: absolute;
        width: 6px;
        height: 6px;
        border-radius: 50%;
    }

    .legend-bar1 {
        background-color: var(--chart-color-10);
        left: 41px;
        top: 6px;
    }

    .legend-bar2 {
        background-color: var(--chart-color-8);
        left: 130px;
        top: 6px;
    }

    .legend-bar3 {
        background-color: var(--chart-color-14);
        left: 210px;
        top: 6px;
    }

    .legend-bar4 {
        background-color: var(--chart-color-1);
        left: 300px;
        top: 6px;
    }

    .legend-bar5 {
        background-color: var(--chart-color-15);
        left: 41px;
        top: 32px;
    }

    .legend-bar6 {
        background-color: var(--chart-color-5);
        left: 130px;
        top: 32px;
    }

    .legend-bar7 {
        background-color: var(--chart-color-3);
        left: 220px;
        top: 32px;
    }

    .legend-bar11 {
        background-color: var(--chart-color-10);
        left: 20px;
        top: 4px;
    }

    .legend-bar22 {
        background-color: var(--chart-color-8);
        left: 105px;
        top: 4px;
    }

    .legend-bar33 {
        background-color: var(--chart-color-14);
        left: 190px;
        top: 4px;
    }

    .legend-bar44 {
        background-color: var(--chart-color-1);
        left: 290px;
        top: 4px;
    }

    .legend-bar55 {
        background-color: var(--chart-color-15);
        left: 20px;
        top: 30px;
    }

    .legend-bar66 {
        background-color: var(--chart-color-5);
        left: 105px;
        top: 30px;
    }

    .legend-bar77 {
        background-color: var(--chart-color-3);
        left: 240px;
        top: 30px;
    }

    .legend-text {
        position: absolute;
        font-size: 13px;
        color: var(--text-color-2);
    }

    .legend-text1 {
        top: 0;
        left: 54px;
    }

    .legend-text2 {
        top: 0;
        left: 143px;
    }

    .legend-text3 {
        top: 0;
        left: 233px;
    }

    .legend-text4 {
        top: 0;
        left: 313px;
    }

    .legend-text5 {
        top: 26px;
        left: 54px;
    }

    .legend-text6 {
        top: 26px;
        left: 143px;
    }

    .legend-text7 {
        top: 26px;
        left: 233px;
    }

    .legend-text11 {
        top: 0;
        left: 35px;
    }

    .legend-text22 {
        top: 0;
        left: 120px;
    }

    .legend-text33 {
        top: 0;
        left: 205px;
    }

    .legend-text44 {
        top: 0;
        left: 303px;
    }

    .legend-text55 {
        top: 27px;
        left: 35px;
    }

    .legend-text66 {
        top: 27px;
        left: 120px;
    }

    .legend-text77 {
        top: 27px;
        left: 255px;
    }

    .time-box {
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/views/status/11staminaLevel.vue